import * as preact from "preact";
import PropTypes from "prop-types";

import RepeatableInputField from "./RepeatableInputField";

import "./style.css";

class RepeatableInputFields extends preact.Component {
    handleAddInputField = () => {
        const { onChange, values } = this.props;

        onChange([
            ...values,
            ""
        ]);
    }

    handleRemoveInputField = index => {
        const { onChange, values } = this.props;

        const updatedValues = values.filter((_, i) => index !== i);

        onChange(updatedValues);
    }

    handleInputChange = (index, value) => {
        const { onChange, values } = this.props;

        const updatedValues = values.map((itemValue, i) => {
            if (index === i) {
                return value;
            }
            return itemValue;
        });

        onChange(updatedValues);
    }

    render() {
        const {
            name,
            maxInputsLength,
            values,
            inputPlaceholder,
            inputValidate
        } = this.props;

        const hideAddMoreButton = maxInputsLength === values.length;
        const isOnlyInput = values.length === 1;

        return (
            <div class="repeatableInputFields">
                {values.map((value, index) => (
                    <RepeatableInputField
                        key={index}
                        index={index}
                        name={name}
                        value={value}
                        placeholder={inputPlaceholder}
                        onChange={this.handleInputChange}
                        onDelete={!isOnlyInput && this.handleRemoveInputField}
                        validate={inputValidate}/>
                ))}
                {!hideAddMoreButton && <button type="button" class="addMoreButton" onClick={this.handleAddInputField}>+ Add more</button>}
            </div>
        );
    }
}

RepeatableInputFields.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    inputValidate: PropTypes.func,
    values: PropTypes.array,
    inputPlaceholder: PropTypes.string,
    maxInputsLength: PropTypes.number
};

RepeatableInputFields.defaultProps = {
    values: [""]
};

export default RepeatableInputFields;
